import { __decorate, __metadata } from 'tslib';
import * as i0 from '@angular/core';
import { Injectable, Component, Input, EventEmitter, Output, ViewChild, ChangeDetectionStrategy, NgModule } from '@angular/core';
import { untilDestroyed, UntilDestroy } from '@ngneat/until-destroy';
import * as i3$1 from '@rogers/cdk/common/classes';
import { ModalInjectableData } from '@rogers/cdk/common/classes';
import * as i2 from '@rogers/cdk/modal';
import { ModalService, ModalModule } from '@rogers/cdk/modal';
import { filter, withLatestFrom, tap, map, take, mergeMap, catchError } from 'rxjs/operators';
import * as i3 from '@ngx-translate/core';
import { TranslateModule } from '@ngx-translate/core';
import * as i1 from '@ngrx/store';
import { createAction, props, createReducer, on, createFeatureSelector, createSelector, StoreModule } from '@ngrx/store';
import { of } from 'rxjs';
import { createEntityAdapter } from '@ngrx/entity';
import * as i4 from '@rogers/cdk/button';
import { ButtonComponent } from '@rogers/cdk/button';
import * as i5 from '@rogers/cdk/link';
import { LinkComponent } from '@rogers/cdk/link';
import * as i1$1 from '@rogers/cdk/table';
import { TableModule } from '@rogers/cdk/table';
import * as i1$2 from '@angular/common';
import { CommonModule, CurrencyPipe, DatePipe } from '@angular/common';
import * as i3$2 from '@rogers/cdk/alert';
import { AlertComponent } from '@rogers/cdk/alert';
import * as i4$1 from '@rogers/cdk/icon';
import { IconComponent } from '@rogers/cdk/icon';
import * as i7 from '@rogers/cdk/stepper';
import { StepperModule } from '@rogers/cdk/stepper';
import { get, round } from 'lodash';
import * as i5$2 from '@rogers/cdk/price';
import { PriceComponent } from '@rogers/cdk/price';
import * as i6$1 from '@rogers/cdk/progress-spinner';
import { ProgressSpinnerComponent } from '@rogers/cdk/progress-spinner';
import * as i2$1 from '@angular/forms';
import { FormControl, Validators, UntypedFormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import dayjs from 'dayjs';
import 'dayjs/locale/fr';
import * as i6 from '@rogers/cdk/form';
import { FormModule } from '@rogers/cdk/form';
import * as i4$2 from '@rogers/self-serve-utils/amount-field';
import { AmountFieldModule } from '@rogers/self-serve-utils/amount-field';
import * as i5$1 from '@rogers/self-serve-analytics';
import { AnalyticsModule } from '@rogers/self-serve-analytics';
import * as i1$3 from '@ngrx/effects';
import { createEffect, ofType, EffectsModule } from '@ngrx/effects';
import * as i3$3 from '@angular/common/http';
const _c0 = (a0, a1) => [a0, "CAD", "symbol-narrow", "1.2-2", a1];
function PtpInstallmentComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 2);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "promise-to-pay.ptp-installment.setup-details"), " ");
  }
}
function PtpInstallmentComponent_th_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 12);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "promise-to-pay.ptp-installment.installment-amount"), " ");
  }
}
function PtpInstallmentComponent_td_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 13);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "currency");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const element_r1 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBindV(2, 1, i0.ɵɵpureFunction2(7, _c0, element_r1.amount, ctx_r1.language)), " ");
  }
}
function PtpInstallmentComponent_th_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 12);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "promise-to-pay.ptp-installment.payment-date"), " ");
  }
}
function PtpInstallmentComponent_td_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 13);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "date");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const element_r3 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind4(2, 1, element_r3.date, "longDate", "", ctx_r1.language + "-CA"), " ");
  }
}
function PtpInstallmentComponent_th_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 12);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "promise-to-pay.ptp-installment.payment-method"), " ");
  }
}
function PtpInstallmentComponent_td_13_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 13);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const element_r4 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "promise-to-pay.ptp-installment.payment-methods." + element_r4.paymentMethod), " ");
  }
}
function PtpInstallmentComponent_th_15_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 12);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "promise-to-pay.ptp-installment.status"));
  }
}
function PtpInstallmentComponent_td_16_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 13);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const element_r5 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "promise-to-pay.ptp-installment.status-text." + element_r5.status), " ");
  }
}
function PtpInstallmentComponent_tr_17_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "tr", 14);
  }
}
function PtpInstallmentComponent_tr_18_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "tr", 15);
  }
}
const _c1 = (a0, a1) => ({
  amount: a0,
  date: a1
});
const _c2 = ["dpFirstContainer"];
const _c3 = ["dpSecondContainer"];
const _c4 = a0 => ({
  amount: a0
});
const _c5 = a0 => ({
  days: a0
});
function MultiPtpComponent_For_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 7);
    i0.ɵɵelement(1, "span", 22);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r2 = ctx.$implicit;
    i0.ɵɵproperty("value", item_r2.value);
    i0.ɵɵadvance();
    i0.ɵɵproperty("translate", item_r2.copy);
  }
}
function MultiPtpComponent_Conditional_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ds-error", 8);
    i0.ɵɵpipe(1, "translate");
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("error", ctx_r2.ptpAnalyticsConfig.paymentMethodFormError)("errorMessage", i0.ɵɵpipeBind1(1, 2, "promise-to-pay.setup-ptp.required-field"));
  }
}
function MultiPtpComponent_Conditional_26_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ds-error", 8);
    i0.ɵɵpipe(1, "translate");
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("error", ctx_r2.ptpAnalyticsConfig.paymentDateFormError)("errorMessage", i0.ɵɵpipeBind1(1, 2, "promise-to-pay.setup-ptp.date-alt"));
  }
}
function MultiPtpComponent_Conditional_27_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ds-error", 8);
    i0.ɵɵpipe(1, "translate");
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("error", ctx_r2.ptpAnalyticsConfig.paymentDateFormError)("errorMessage", i0.ɵɵpipeBind1(1, 2, "promise-to-pay.setup-ptp.date-invalid-field-text"));
  }
}
function MultiPtpComponent_Conditional_42_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ds-error", 8);
    i0.ɵɵpipe(1, "translate");
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("error", ctx_r2.ptpAnalyticsConfig.paymentDateFormError)("errorMessage", i0.ɵɵpipeBind1(1, 2, "promise-to-pay.setup-ptp.date-alt"));
  }
}
function MultiPtpComponent_Conditional_43_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ds-error", 8);
    i0.ɵɵpipe(1, "translate");
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("error", ctx_r2.ptpAnalyticsConfig.paymentDateFormError)("errorMessage", i0.ɵɵpipeBind1(1, 2, "promise-to-pay.setup-ptp.date-invalid-field-text"));
  }
}
const _c6 = ["dpContainer"];
function SinglePtpComponent_For_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 6);
    i0.ɵɵelement(1, "span", 14);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r2 = ctx.$implicit;
    i0.ɵɵproperty("value", item_r2.value);
    i0.ɵɵadvance();
    i0.ɵɵproperty("translate", item_r2.copy);
  }
}
function SinglePtpComponent_Conditional_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ds-error", 7);
    i0.ɵɵpipe(1, "translate");
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("error", ctx_r2.ptpAnalyticsConfig.paymentMethodFormError)("errorMessage", i0.ɵɵpipeBind1(1, 2, "promise-to-pay.setup-ptp.required-field"));
  }
}
function SinglePtpComponent_Conditional_19_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ds-error", 7);
    i0.ɵɵpipe(1, "translate");
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("error", ctx_r2.ptpAnalyticsConfig.paymentDateFormError)("errorMessage", i0.ɵɵpipeBind1(1, 2, "promise-to-pay.setup-ptp.date-alt"));
  }
}
function SinglePtpComponent_Conditional_20_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ds-error", 7);
    i0.ɵɵpipe(1, "translate");
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("error", ctx_r2.ptpAnalyticsConfig.paymentDateFormError)("errorMessage", i0.ɵɵpipeBind1(1, 2, "promise-to-pay.setup-ptp.date-invalid-field-text"));
  }
}
const _c7 = a0 => ({
  "mt-24": true,
  "mr-md-24": a0
});
function PromiseToPayOptionsComponent_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 1);
    i0.ɵɵpipe(1, "translate");
  }
  if (rf & 2) {
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(1, 1, "promise-to-pay.single-ptp-note"), i0.ɵɵsanitizeHtml);
  }
}
function PromiseToPayOptionsComponent_For_8_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ds-selection", 5);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵlistener("change", function PromiseToPayOptionsComponent_For_8_Template_ds_selection_change_0_listener($event) {
      const option_r2 = i0.ɵɵrestoreView(_r1).$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.selectedPTP(option_r2.copy, $event.value));
    });
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const option_r2 = ctx.$implicit;
    const ɵ$index_15_r4 = ctx.$index;
    const ɵ$count_15_r5 = ctx.$count;
    i0.ɵɵproperty("caption", i0.ɵɵpipeBind1(1, 5, option_r2.caption))("hasPadding", true)("ngClass", i0.ɵɵpureFunction1(9, _c7, !(ɵ$index_15_r4 === ɵ$count_15_r5 - 1)))("value", option_r2.value);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 7, option_r2.copy), " ");
  }
}
function PromiseToPayFormsComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ss-multi-ptp", 6);
    i0.ɵɵlistener("ptpFormDetails", function PromiseToPayFormsComponent_Conditional_2_Template_ss_multi_ptp_ptpFormDetails_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.setup($event));
    })("setEligibleDates", function PromiseToPayFormsComponent_Conditional_2_Template_ss_multi_ptp_setEligibleDates_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.setMultiPTPEligibleDates($event));
    })("trackEvent", function PromiseToPayFormsComponent_Conditional_2_Template_ss_multi_ptp_trackEvent_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.trackEvent.emit($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("firstInstallmentEligibleDates", ctx_r1.firstInstallmentEligibleDates)("language", ctx_r1.language)("dateFormat", ctx_r1.dateFormat)("firstEligibleDays", ctx_r1.firstEligibleDays)("pastDueBalance", ctx_r1.pastDueBalance)("paymentOptions", ctx_r1.paymentOptions)("ptpAnalyticsConfig", ctx_r1.ptpAnalyticsConfig)("recommendedAmount", ctx_r1.recommendedAmount)("secondInstallmentEligibleDates", ctx_r1.secondInstallmentEligibleDates);
  }
}
function PromiseToPayFormsComponent_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ss-single-ptp", 7);
    i0.ɵɵlistener("ptpFormDetails", function PromiseToPayFormsComponent_Conditional_3_Template_ss_single_ptp_ptpFormDetails_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.setup($event));
    })("setEligibleDates", function PromiseToPayFormsComponent_Conditional_3_Template_ss_single_ptp_setEligibleDates_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.setEligibleDates($event));
    })("trackEvent", function PromiseToPayFormsComponent_Conditional_3_Template_ss_single_ptp_trackEvent_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.trackEvent.emit($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("language", ctx_r1.language)("dateFormat", ctx_r1.dateFormat)("pastDueBalance", ctx_r1.pastDueBalance)("paymentOptions", ctx_r1.paymentOptions)("ptpAnalyticsConfig", ctx_r1.ptpAnalyticsConfig)("singlePTPEligibleDates", ctx_r1.firstInstallmentEligibleDates);
  }
}
const _c8 = a0 => ({
  "ds-color-dark-warning": a0
});
function PromiseToPayMessageComponent_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 4);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c8, (ctx_r0.config == null ? null : ctx_r0.config.alertVariant) === "warning"));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 2, ctx_r0.config == null ? null : ctx_r0.config.heading), " ");
  }
}
function PromiseToPayMessageComponent_Conditional_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6)(1, "a", 7);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("href", ctx_r0.config == null ? null : ctx_r0.config.alertLinkUrl, i0.ɵɵsanitizeUrl);
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(2, 3, ctx_r0.config == null ? null : ctx_r0.config.alertLinkAlt));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(4, 5, ctx_r0.config == null ? null : ctx_r0.config.alertLinkCopy), " ");
  }
}
const _c9 = ["ptpStepper"];
const _c10 = a0 => ({
  container: a0
});
function PromiseToPaySetupComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "h1");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "promise-to-pay.header"));
  }
}
function PromiseToPaySetupComponent_Conditional_2_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 3);
    i0.ɵɵpipe(1, "translate");
  }
  if (rf & 2) {
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(1, 1, "promise-to-pay.body-n-type"), i0.ɵɵsanitizeHtml);
  }
}
function PromiseToPaySetupComponent_Conditional_2_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵelement(1, "span", 6);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementStart(3, "a", 7);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵlistener("click", function PromiseToPaySetupComponent_Conditional_2_Conditional_1_Template_a_click_3_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.navigateTo("payments/pay"));
    });
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(8, "div", 5);
    i0.ɵɵtext(9);
    i0.ɵɵpipe(10, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(2, 5, "promise-to-pay.body"), i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("arial-label", i0.ɵɵpipeBind1(4, 7, "promise-to-pay.make-payment-here-alt"))("title", i0.ɵɵpipeBind1(5, 9, "promise-to-pay.make-payment-here-alt"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(7, 11, "promise-to-pay.make-payment-here"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(10, 13, "promise-to-pay.note"));
  }
}
function PromiseToPaySetupComponent_Conditional_2_Conditional_2_Conditional_18_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" - ", i0.ɵɵpipeBind1(2, 1, "promise-to-pay.ptp-option.multi"), "");
  }
}
function PromiseToPaySetupComponent_Conditional_2_Conditional_2_Conditional_19_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" - ", i0.ɵɵpipeBind1(2, 1, "promise-to-pay.ptp-option.single"), "");
  }
}
function PromiseToPaySetupComponent_Conditional_2_Conditional_2_Conditional_31_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 6);
    i0.ɵɵpipe(1, "translate");
  }
  if (rf & 2) {
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(1, 1, "promise-to-pay.review-note-n-type"), i0.ɵɵsanitizeHtml);
  }
}
function PromiseToPaySetupComponent_Conditional_2_Conditional_2_Conditional_51_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ss-ptp-installment", 18);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("language", ctx_r1.language)("tableData", ctx_r1.ptpTableData)("showSetupDetailsText", true)("showPaymentStatus", false);
  }
}
function PromiseToPaySetupComponent_Conditional_2_Conditional_2_Conditional_51_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelement(0, "ss-promise-to-pay-message", 22);
    i0.ɵɵtemplate(1, PromiseToPaySetupComponent_Conditional_2_Conditional_2_Conditional_51_Conditional_1_Template, 1, 4, "ss-ptp-installment", 18);
    i0.ɵɵelementStart(2, "div", 19)(3, "a", 23);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵlistener("click", function PromiseToPaySetupComponent_Conditional_2_Conditional_2_Conditional_51_Template_a_click_3_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.navigateTo("overview"));
    });
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("config", ctx_r1.confirmationConfig);
    i0.ɵɵadvance();
    i0.ɵɵconditional(1, ctx_r1.confirmationConfig.isSuccess ? 1 : -1);
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(4, 4, ctx_r1.confirmationConfig == null ? null : ctx_r1.confirmationConfig.buttonAlt));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(6, 6, ctx_r1.confirmationConfig == null ? null : ctx_r1.confirmationConfig.buttonLabel), " ");
  }
}
function PromiseToPaySetupComponent_Conditional_2_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 4)(1, "div", 8);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelement(4, "ds-price", 9);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "ds-stepper", 10, 0);
    i0.ɵɵpipe(7, "translate");
    i0.ɵɵelementStart(8, "ds-step", 11);
    i0.ɵɵpipe(9, "translate");
    i0.ɵɵpipe(10, "translate");
    i0.ɵɵelementStart(11, "div", 12);
    i0.ɵɵtext(12);
    i0.ɵɵpipe(13, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "div", 13)(15, "span", 14);
    i0.ɵɵtext(16);
    i0.ɵɵpipe(17, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(18, PromiseToPaySetupComponent_Conditional_2_Conditional_2_Conditional_18_Template, 3, 3, "span")(19, PromiseToPaySetupComponent_Conditional_2_Conditional_2_Conditional_19_Template, 3, 3, "span");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(20, "div", 15)(21, "ss-promise-to-pay-forms", 16);
    i0.ɵɵlistener("cancelPTP", function PromiseToPaySetupComponent_Conditional_2_Conditional_2_Template_ss_promise_to_pay_forms_cancelPTP_21_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.navigateTo($event));
    })("selectedPTPOption", function PromiseToPaySetupComponent_Conditional_2_Conditional_2_Template_ss_promise_to_pay_forms_selectedPTPOption_21_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.selectedPTPOption($event));
    })("setupPTP", function PromiseToPaySetupComponent_Conditional_2_Conditional_2_Template_ss_promise_to_pay_forms_setupPTP_21_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.reviewPTP($event));
    })("trackEvent", function PromiseToPaySetupComponent_Conditional_2_Conditional_2_Template_ss_promise_to_pay_forms_trackEvent_21_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.trackFormFieldAndButtonInteraction($event));
    });
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(22, "ds-step", 17)(23, "div", 12)(24, "div", 14);
    i0.ɵɵtext(25);
    i0.ɵɵpipe(26, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(27, "div", 15)(28, "div", 14);
    i0.ɵɵtext(29);
    i0.ɵɵpipe(30, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(31, PromiseToPaySetupComponent_Conditional_2_Conditional_2_Conditional_31_Template, 2, 3, "div", 6);
    i0.ɵɵelement(32, "ss-ptp-installment", 18);
    i0.ɵɵelementStart(33, "div", 19)(34, "button", 20);
    i0.ɵɵpipe(35, "translate");
    i0.ɵɵlistener("click", function PromiseToPaySetupComponent_Conditional_2_Conditional_2_Template_button_click_34_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.setupPTP());
    });
    i0.ɵɵtext(36);
    i0.ɵɵpipe(37, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(38, "button", 21);
    i0.ɵɵpipe(39, "translate");
    i0.ɵɵlistener("click", function PromiseToPaySetupComponent_Conditional_2_Conditional_2_Template_button_click_38_listener() {
      i0.ɵɵrestoreView(_r3);
      const ptpStepper_r4 = i0.ɵɵreference(6);
      return i0.ɵɵresetView(ptpStepper_r4.previous());
    });
    i0.ɵɵtext(40);
    i0.ɵɵpipe(41, "translate");
    i0.ɵɵelementEnd()()()();
    i0.ɵɵelementStart(42, "ds-step", 17)(43, "div", 12)(44, "div", 14);
    i0.ɵɵtext(45);
    i0.ɵɵpipe(46, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(47, "div", 15)(48, "div", 14);
    i0.ɵɵtext(49);
    i0.ɵɵpipe(50, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(51, PromiseToPaySetupComponent_Conditional_2_Conditional_2_Conditional_51_Template, 7, 8);
    i0.ɵɵelementEnd()()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 39, "promise-to-pay.setup-ptp.total-balance"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("price", ctx_r1.pastDueBalance)("language", ctx_r1.language);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ariaLabel", i0.ɵɵpipeBind1(7, 41, "promise-to-pay.header"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("buttonCopy", i0.ɵɵpipeBind1(9, 43, "promise-to-pay.edit"))("buttonCaption", i0.ɵɵpipeBind1(10, 45, "promise-to-pay.edit"))("completed", true)("editState", ctx_r1.editState)("required", true);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(13, 47, "promise-to-pay.header"));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(17, 49, "promise-to-pay.select-ptp-option"));
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(18, ctx_r1.ptpOption === "multi" ? 18 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(19, ctx_r1.ptpOption === "single" ? 19 : -1);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("currentDate", ctx_r1.currentDate)("language", ctx_r1.language)("pastDueBalance", ctx_r1.pastDueBalance)("ptpAnalyticsConfig", ctx_r1.ptpAnalyticsConfig)("recommendedAmount", ctx_r1.recommendedAmount);
    i0.ɵɵadvance();
    i0.ɵɵproperty("required", false)("completed", false)("editState", "hidden");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(26, 51, "promise-to-pay.review"));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(30, 53, "promise-to-pay.review"));
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(31, ctx_r1.isPtpNType ? 31 : -1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("language", ctx_r1.language)("tableData", ctx_r1.ptpTableData)("showSetupDetailsText", true)("showPaymentStatus", false);
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(35, 55, "promise-to-pay.setup-ptp.setup-btn-alt"));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(37, 57, "promise-to-pay.setup-ptp.setup-btn"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("variant", "secondary");
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(39, 59, "promise-to-pay.setup-ptp.cancel-btn-alt"));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(41, 61, "promise-to-pay.setup-ptp.cancel-btn"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("required", false)("completed", false)("editState", "hidden");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(46, 63, "promise-to-pay.confirmation"));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(50, 65, "promise-to-pay.confirmation"));
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(51, !!ctx_r1.confirmationConfig ? 51 : -1);
  }
}
function PromiseToPaySetupComponent_Conditional_2_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ss-promise-to-pay-message", 22);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("config", ctx_r1.notEligibleMessageConfig);
  }
}
function PromiseToPaySetupComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, PromiseToPaySetupComponent_Conditional_2_Conditional_0_Template, 2, 3, "div", 3)(1, PromiseToPaySetupComponent_Conditional_2_Conditional_1_Template, 11, 15)(2, PromiseToPaySetupComponent_Conditional_2_Conditional_2_Template, 52, 67, "div", 4)(3, PromiseToPaySetupComponent_Conditional_2_Conditional_3_Template, 1, 1);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵconditional(0, ctx_r1.isPtpNType ? 0 : 1);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(2, ctx_r1.isPtpEligible ? 2 : 3);
  }
}
function PromiseToPaySetupComponent_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ds-progress-spinner", 2);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵpipe(2, "translate");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("a11yLoadingCopy", i0.ɵɵpipeBind1(1, 3, "progress-spinner.loading"))("a11yLoadedCopy", i0.ɵɵpipeBind1(2, 5, "progress-spinner.loaded"))("isLoading", ctx_r1.isLoading);
  }
}
class PromiseToPayConfigService {}
const clearPromiseToPay = createAction('[PromiseToPay] Clear Promise To Pay');
const loadPromiseToPay = createAction('[PromiseToPay] Load Promise To Pay', props());
const loadPromiseToPayFail = createAction('[PromiseToPay] Load Promise To Pay failed', props());
const loadPromiseToPaySuccess = createAction('[PromiseToPay] Load Promise To Pay success', props());
const promiseToPayStateName = 'promiseToPay';
const adapter = createEntityAdapter({
  selectId: promiseToPayEntity => promiseToPayEntity.accountNumber
});
const initialState = adapter.getInitialState({
  // additional entity state properties
});
const createPromiseToPayReducer = createReducer(initialState, on(loadPromiseToPay, (state, action) => adapter.upsertOne({
  ...action.payload,
  error: null,
  hasError: false,
  loaded: false,
  loading: true
}, state)), on(loadPromiseToPaySuccess, (state, action) => adapter.upsertOne({
  ...action.payload,
  hasError: false,
  loaded: true,
  loading: false
}, state)), on(loadPromiseToPayFail, (state, action) => adapter.upsertOne({
  ...action.payload,
  hasError: true,
  loaded: false,
  loading: false
}, state)), on(clearPromiseToPay, state => adapter.removeAll(state)));
// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
function promiseToPayReducer(state, action) {
  return createPromiseToPayReducer(state, action);
}
const {
  selectEntities
} = adapter.getSelectors();
const promiseToPayEntityState = createFeatureSelector(promiseToPayStateName);
const selectPromiseToPayEntities = createSelector(promiseToPayEntityState, selectEntities);
const selectPromiseToPayEntity = createSelector(selectPromiseToPayEntities, promiseToPayEntities => accountNumber => promiseToPayEntities[accountNumber]);
const selectedAccountPtpInstallments = createSelector(selectPromiseToPayEntities, promiseToPayEntities => accountNumber => promiseToPayEntities[accountNumber].installments);
const getPromiseToPay = accountNumber => createSelector(selectPromiseToPayEntity, f => f(accountNumber));
let PromiseToPayFacadeService = /*#__PURE__*/(() => {
  class PromiseToPayFacadeService {
    constructor(store) {
      this.store = store;
    }
    getPromiseToPay$(accountNumber) {
      return this.getPromiseToPayEntity$(accountNumber).pipe(filter(promiseToPayEntity => !!promiseToPayEntity && (promiseToPayEntity.loaded || promiseToPayEntity.hasError)));
    }
    loadPromiseToPay$(accountNumber, accountAlias, refresh = false) {
      return of(accountNumber).pipe(withLatestFrom(this.getPromiseToPayEntity$(accountNumber)), tap(([_, promiseToPayEntity]) => {
        if (!!promiseToPayEntity && (promiseToPayEntity.loaded || promiseToPayEntity.loading) && !refresh) {
          return;
        }
        return this.store.dispatch(loadPromiseToPay({
          payload: {
            accountNumber,
            accountAlias
          }
        }));
      }));
    }
    getPtpInstallmentsForAccountNumber$(accountNumber) {
      return this.getPromiseToPay$(accountNumber).pipe(map(promiseToPay => promiseToPay.installments));
    }
    getPromiseToPayEntity$(accountNumber) {
      return this.store.select(getPromiseToPay(accountNumber));
    }
    /** @nocollapse */
    static {
      this.ɵfac = function PromiseToPayFacadeService_Factory(t) {
        return new (t || PromiseToPayFacadeService)(i0.ɵɵinject(i1.Store));
      };
    }
    /** @nocollapse */
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: PromiseToPayFacadeService,
        factory: PromiseToPayFacadeService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return PromiseToPayFacadeService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let PtpInstallmentComponent = /*#__PURE__*/(() => {
  class PtpInstallmentComponent {
    constructor() {
      this.showPaymentStatus = true;
    }
    get displayedColumns() {
      const columns = ['installmentAmount', 'paymentDate', 'paymentMethod'];
      if (this.showPaymentStatus) {
        columns.push('status');
      }
      return columns;
    }
    /** @nocollapse */
    static {
      this.ɵfac = function PtpInstallmentComponent_Factory(t) {
        return new (t || PtpInstallmentComponent)();
      };
    }
    /** @nocollapse */
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: PtpInstallmentComponent,
        selectors: [["ss-ptp-installment"]],
        inputs: {
          language: "language",
          tableData: "tableData",
          showSetupDetailsText: "showSetupDetailsText",
          showPaymentStatus: "showPaymentStatus"
        },
        decls: 19,
        vars: 8,
        consts: [["ptpInstallmentTableContainer", ""], ["ptpInstallmentTable", ""], [1, "text-title-5", "mb-16"], ["ds-table", "", "borderType", "row", 3, "dataSource"], ["dsTableColumnDef", "installmentAmount", 3, "textAlign"], ["ds-table-header-cell", "", 4, "dsTableHeaderCellDef"], ["ds-table-cell", "", 4, "dsTableCellDef"], ["dsTableColumnDef", "paymentDate", 3, "textAlign"], ["dsTableColumnDef", "paymentMethod", 3, "textAlign"], ["dsTableColumnDef", "status", 3, "textAlign"], ["ds-table-header-row", "", 4, "dsTableHeaderRowDef"], ["ds-table-row", "", 4, "dsTableRowDef", "dsTableRowDefColumns"], ["ds-table-header-cell", ""], ["ds-table-cell", ""], ["ds-table-header-row", ""], ["ds-table-row", ""]],
        template: function PtpInstallmentComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, PtpInstallmentComponent_Conditional_0_Template, 3, 3, "p", 2);
            i0.ɵɵelementStart(1, "ds-table-container", null, 0)(3, "table", 3, 1);
            i0.ɵɵelementContainerStart(5, 4);
            i0.ɵɵtemplate(6, PtpInstallmentComponent_th_6_Template, 3, 3, "th", 5)(7, PtpInstallmentComponent_td_7_Template, 3, 10, "td", 6);
            i0.ɵɵelementContainerEnd();
            i0.ɵɵelementContainerStart(8, 7);
            i0.ɵɵtemplate(9, PtpInstallmentComponent_th_9_Template, 3, 3, "th", 5)(10, PtpInstallmentComponent_td_10_Template, 3, 6, "td", 6);
            i0.ɵɵelementContainerEnd();
            i0.ɵɵelementContainerStart(11, 8);
            i0.ɵɵtemplate(12, PtpInstallmentComponent_th_12_Template, 3, 3, "th", 5)(13, PtpInstallmentComponent_td_13_Template, 3, 3, "td", 6);
            i0.ɵɵelementContainerEnd();
            i0.ɵɵelementContainerStart(14, 9);
            i0.ɵɵtemplate(15, PtpInstallmentComponent_th_15_Template, 3, 3, "th", 5)(16, PtpInstallmentComponent_td_16_Template, 3, 3, "td", 6);
            i0.ɵɵelementContainerEnd();
            i0.ɵɵtemplate(17, PtpInstallmentComponent_tr_17_Template, 1, 0, "tr", 10)(18, PtpInstallmentComponent_tr_18_Template, 1, 0, "tr", 11);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵconditional(0, ctx.showSetupDetailsText ? 0 : -1);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("dataSource", ctx.tableData);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("textAlign", "left");
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("textAlign", "left");
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("textAlign", "left");
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("textAlign", "left");
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("dsTableHeaderRowDef", ctx.displayedColumns);
            i0.ɵɵadvance();
            i0.ɵɵproperty("dsTableRowDefColumns", ctx.displayedColumns);
          }
        },
        dependencies: [i1$1.TableHeaderRowComponent, i1$1.TableHeaderRowDefDirective, i1$1.TableRowDefDirective, i1$1.TableRowComponent, i1$1.TableComponent, i1$1.CellDirective, i1$1.TableCellDefDirective, i1$1.TableColumnDefDirective, i1$1.TableHeaderCell, i1$1.TableHeaderCellDef, i1$1.TableContainerComponent, i1$2.CurrencyPipe, i1$2.DatePipe, i3.TranslatePipe],
        encapsulation: 2
      });
    }
  }
  return PtpInstallmentComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let PtpInfoModalComponent = /*#__PURE__*/(() => {
  class PtpInfoModalComponent {
    constructor(promiseToPayFacadeService, translateService, modalData) {
      this.promiseToPayFacadeService = promiseToPayFacadeService;
      this.translateService = translateService;
      this.modalData = modalData;
      this.navigate = new EventEmitter();
      const accountNumber = this.modalData.source.accountNumber;
      this.tableData$ = this.promiseToPayFacadeService.getPtpInstallmentsForAccountNumber$(accountNumber);
    }
    get language() {
      return this.translateService.currentLang;
    }
    navigateTo(url) {
      this.navigate.emit(url);
    }
    /** @nocollapse */
    static {
      this.ɵfac = function PtpInfoModalComponent_Factory(t) {
        return new (t || PtpInfoModalComponent)(i0.ɵɵdirectiveInject(PromiseToPayFacadeService), i0.ɵɵdirectiveInject(i3.TranslateService), i0.ɵɵdirectiveInject(i3$1.ModalInjectableData));
      };
    }
    /** @nocollapse */
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: PtpInfoModalComponent,
        selectors: [["ss-ptp-info-modal"]],
        outputs: {
          navigate: "navigate"
        },
        decls: 15,
        vars: 23,
        consts: [[3, "heading", "closeCaption"], ["body", ""], [3, "language", "tableData", "showSetupDetailsText"], ["footer", ""], ["ds-button", "", 1, "mr-xs-16", 3, "click"], ["ds-link", "", 3, "click"]],
        template: function PtpInfoModalComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "ds-modal", 0);
            i0.ɵɵpipe(1, "translate");
            i0.ɵɵpipe(2, "translate");
            i0.ɵɵelementStart(3, "div", 1);
            i0.ɵɵelement(4, "ss-ptp-installment", 2);
            i0.ɵɵpipe(5, "async");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(6, "div", 3)(7, "a", 4);
            i0.ɵɵpipe(8, "translate");
            i0.ɵɵlistener("click", function PtpInfoModalComponent_Template_a_click_7_listener() {
              return ctx.navigateTo("payments/pay");
            });
            i0.ɵɵtext(9);
            i0.ɵɵpipe(10, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(11, "a", 5);
            i0.ɵɵpipe(12, "translate");
            i0.ɵɵlistener("click", function PtpInfoModalComponent_Template_a_click_11_listener() {
              return ctx.navigateTo("payments/history");
            });
            i0.ɵɵtext(13);
            i0.ɵɵpipe(14, "translate");
            i0.ɵɵelementEnd()()();
          }
          if (rf & 2) {
            i0.ɵɵproperty("heading", i0.ɵɵpipeBind1(1, 9, "promise-to-pay.ptp-info-modal.title"))("closeCaption", i0.ɵɵpipeBind1(2, 11, "common.cta.close"));
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("language", ctx.language)("tableData", i0.ɵɵpipeBind1(5, 13, ctx.tableData$))("showSetupDetailsText", false);
            i0.ɵɵadvance(3);
            i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(8, 15, "promise-to-pay.ptp-info-modal.make-payment-button-alt"));
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(10, 17, "promise-to-pay.ptp-info-modal.make-payment-button"), " ");
            i0.ɵɵadvance(2);
            i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(12, 19, "promise-to-pay.ptp-info-modal.payment-history-link-alt"));
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(14, 21, "promise-to-pay.ptp-info-modal.payment-history-link"), " ");
          }
        },
        dependencies: [i4.ButtonComponent, i5.LinkComponent, i2.ModalComponent, PtpInstallmentComponent, i1$2.AsyncPipe, i3.TranslatePipe],
        encapsulation: 2
      });
    }
  }
  return PtpInfoModalComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let PromiseToPayAlertComponent = /*#__PURE__*/(() => {
  let PromiseToPayAlertComponent = class PromiseToPayAlertComponent {
    constructor(config, modalService) {
      this.config = config;
      this.modalService = modalService;
    }
    ngOnInit() {
      this.setAlertConfig();
    }
    handleCtaClick() {
      if (this.setupPtp) {
        return this.config.navigateTo('promise-to-pay');
      }
      return this.openPtpInfoModal();
    }
    openPtpInfoModal() {
      this.modalRef = this.modalService.open(PtpInfoModalComponent, this.config.viewContainerRef, this.config.modalWindowConfig, new ModalInjectableData({
        language: this.language,
        installments: this.ptpInstallments
      }));
      this.modalRef.componentInstance.navigate.pipe(untilDestroyed(this), tap(url => {
        this.config.navigateTo(url);
        this.modalRef.close();
      })).subscribe();
    }
    setAlertConfig() {
      const alertType = this.setupPtp ? 'setup' : 'pending';
      const alertBody = this.isSinglePtp ? 'single-ptp' : 'multi-ptp';
      this.alertData = {
        copy: {
          body: alertType === 'pending' ? `promise-to-pay.alerts.${alertType}.${alertBody}` : `promise-to-pay.alerts.${alertType}.body`,
          closeLabel: `promise-to-pay.alerts.${alertType}.close-label`
        },
        cta: [{
          copy: `promise-to-pay.alerts.${alertType}.link-text`,
          alt: `promise-to-pay.alerts.${alertType}.link-text-alt`
        }]
      };
    }
    /** @nocollapse */
    static {
      this.ɵfac = function PromiseToPayAlertComponent_Factory(t) {
        return new (t || PromiseToPayAlertComponent)(i0.ɵɵdirectiveInject(PromiseToPayConfigService), i0.ɵɵdirectiveInject(i2.ModalService));
      };
    }
    /** @nocollapse */
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: PromiseToPayAlertComponent,
        selectors: [["ss-promise-to-pay-alert"]],
        inputs: {
          isSinglePtp: "isSinglePtp",
          language: "language",
          pastDueBalance: "pastDueBalance",
          ptpDueDate: "ptpDueDate",
          ptpInstallments: "ptpInstallments",
          setupPtp: "setupPtp"
        },
        decls: 17,
        vars: 36,
        consts: [["variant", "info", 3, "closeLabel"], [1, "d-flex", "flex-column", "flex-md-row"], [1, "flex-grow-1", "d-flex"], ["color", "info", "name", "info-outlined", 1, "mr-8", 3, "caption"], [1, "text-body", "mb-0", "mw-content", 3, "innerHTML"], [1, "d-flex", "flex-wrap", "flex-shrink-0", "align-self-md-start", "pl-16", "pl-md-0", "-mt-md-12"], ["ds-link", "", 1, "mt-8", "mt-md-0", "ml-16", 3, "click", "title"], [3, "innerHTML"]],
        template: function PromiseToPayAlertComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "ds-alert", 0);
            i0.ɵɵpipe(1, "translate");
            i0.ɵɵelementStart(2, "div", 1)(3, "div", 2);
            i0.ɵɵelement(4, "ds-icon", 3);
            i0.ɵɵpipe(5, "translate");
            i0.ɵɵelementStart(6, "div");
            i0.ɵɵelement(7, "p", 4);
            i0.ɵɵpipe(8, "currency");
            i0.ɵɵpipe(9, "date");
            i0.ɵɵpipe(10, "translate");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(11, "div", 5)(12, "a", 6);
            i0.ɵɵpipe(13, "translate");
            i0.ɵɵpipe(14, "translate");
            i0.ɵɵlistener("click", function PromiseToPayAlertComponent_Template_a_click_12_listener() {
              return ctx.handleCtaClick();
            });
            i0.ɵɵelement(15, "span", 7);
            i0.ɵɵpipe(16, "translate");
            i0.ɵɵelementEnd()()()();
          }
          if (rf & 2) {
            i0.ɵɵproperty("closeLabel", i0.ɵɵpipeBind1(1, 6, ctx.alertData.copy.closeLabel));
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("caption", i0.ɵɵpipeBind1(5, 8, "promise-to-pay.alerts.icon-caption"));
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(10, 21, ctx.alertData.copy.body, i0.ɵɵpureFunction2(33, _c1, i0.ɵɵpipeBindV(8, 10, i0.ɵɵpureFunction2(30, _c0, ctx.pastDueBalance, ctx.language)), i0.ɵɵpipeBind4(9, 16, ctx.ptpDueDate, "longDate", "", ctx.language + "-CA"))), i0.ɵɵsanitizeHtml);
            i0.ɵɵadvance(5);
            i0.ɵɵproperty("title", i0.ɵɵpipeBind1(13, 24, ctx.alertData.cta[0].alt));
            i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(14, 26, ctx.alertData.cta[0].alt));
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(16, 28, ctx.alertData.cta[0].copy), i0.ɵɵsanitizeHtml);
          }
        },
        dependencies: [i3$2.AlertComponent, i4$1.IconComponent, i5.LinkComponent, i1$2.CurrencyPipe, i1$2.DatePipe, i3.TranslatePipe],
        encapsulation: 2
      });
    }
  };
  PromiseToPayAlertComponent = __decorate([UntilDestroy(), __metadata("design:paramtypes", [PromiseToPayConfigService, ModalService])], PromiseToPayAlertComponent);
  return PromiseToPayAlertComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const ptpDateValueFormat = 'yyyy-MM-dd';
const VALIDATE_PAYMENT_AMOUNT = /^(?=.*[1-9])\d+(?:\.\d{1,2})?$/;
var MultiPtpEligibleDays = /*#__PURE__*/function (MultiPtpEligibleDays) {
  MultiPtpEligibleDays[MultiPtpEligibleDays["BANK_FIRST_INSTALLMENT"] = 6] = "BANK_FIRST_INSTALLMENT";
  MultiPtpEligibleDays[MultiPtpEligibleDays["BANK_SECOND_INSTALLMENT"] = 4] = "BANK_SECOND_INSTALLMENT";
  MultiPtpEligibleDays[MultiPtpEligibleDays["CREDIT_CARD_FIRST_INSTALLMENT"] = 10] = "CREDIT_CARD_FIRST_INSTALLMENT";
  // eslint-disable-next-line
  MultiPtpEligibleDays[MultiPtpEligibleDays["CREDIT_CARD_SECOND_INSTALLMENT"] = 4] = "CREDIT_CARD_SECOND_INSTALLMENT";
  return MultiPtpEligibleDays;
}(MultiPtpEligibleDays || {});
var PtpDetailsColumns = /*#__PURE__*/function (PtpDetailsColumns) {
  PtpDetailsColumns["amount"] = "amount";
  PtpDetailsColumns["paymentDate"] = "paymentDate";
  PtpDetailsColumns["paymentMethod"] = "paymentMethod";
  PtpDetailsColumns["status"] = "status";
  return PtpDetailsColumns;
}(PtpDetailsColumns || {});
var PtpEligibleDays = /*#__PURE__*/function (PtpEligibleDays) {
  PtpEligibleDays[PtpEligibleDays["CARD"] = 9] = "CARD";
  PtpEligibleDays[PtpEligibleDays["BANK"] = 5] = "BANK";
  return PtpEligibleDays;
}(PtpEligibleDays || {});
var PtpInstallmentsStatus = /*#__PURE__*/function (PtpInstallmentsStatus) {
  PtpInstallmentsStatus["Pending"] = "pending";
  PtpInstallmentsStatus["Fulfilled"] = "fulfilled";
  return PtpInstallmentsStatus;
}(PtpInstallmentsStatus || {});
var PtpOptions = /*#__PURE__*/function (PtpOptions) {
  PtpOptions["Multi"] = "multi";
  PtpOptions["Single"] = "single";
  return PtpOptions;
}(PtpOptions || {});
var PtpPaymentMethods = /*#__PURE__*/function (PtpPaymentMethods) {
  PtpPaymentMethods["BANK"] = "PB";
  PtpPaymentMethods["CARD"] = "CC";
  PtpPaymentMethods["CASH"] = "CA";
  PtpPaymentMethods["FIDO_STORE"] = "FS";
  PtpPaymentMethods["MONEY_ORDER"] = "MO";
  PtpPaymentMethods["NR"] = "NR";
  PtpPaymentMethods["ROGERS_STORE"] = "RV";
  return PtpPaymentMethods;
}(PtpPaymentMethods || {});
let MultiPtpComponent = /*#__PURE__*/(() => {
  class MultiPtpComponent {
    constructor(datePipe, formBuilder) {
      this.datePipe = datePipe;
      this.formBuilder = formBuilder;
      this.ptpFormDetails = new EventEmitter();
      this.setEligibleDates = new EventEmitter();
      this.trackEvent = new EventEmitter();
      this.firstInstallmentDate = new FormControl('', [Validators.required]);
      this.secondInstallmentDate = new FormControl('', [Validators.required]);
      this.firstInstallmentAmountControl = new UntypedFormControl('', [Validators.required, Validators.pattern(VALIDATE_PAYMENT_AMOUNT)]);
      this.multiPTPForm = this.formBuilder.group({
        paymentMethod: ['', Validators.required]
      });
      this.secondInstallmentAmountControl = new UntypedFormControl();
    }
    get isValidAmount() {
      if (!!get(this.firstInstallmentAmountControl, 'value', '').toString().match(VALIDATE_PAYMENT_AMOUNT) && this.firstInstallmentAmountControl.value >= this.firstInstallmentAmountValue && this.firstInstallmentAmountControl.value <= this.pastDueBalance) {
        this.firstInstallmentAmountControl.setErrors(null);
        return true;
      }
      return this.handleAmountError;
    }
    get multiPTPFormControls() {
      return this.multiPTPForm.controls;
    }
    get showAmountError() {
      return !(this.firstInstallmentAmountControl && this.firstInstallmentAmountControl.valid && this.isValidAmount) && this.firstInstallmentAmountControl.touched;
    }
    get firstInstallmentAmountValue() {
      return this.recommendedAmount;
    }
    get handleAmountError() {
      if (this.firstInstallmentAmountControl.value > this.pastDueBalance) {
        this.firstInstallmentAmountControl.setErrors({
          greaterThanPastDue: true
        });
        this.firstInstallmentAmountError = 'promise-to-pay.multi-ptp.first-installment-greaterThanPastDue';
        return false;
      }
      this.firstInstallmentAmountControl.setErrors({
        atLeastMinimum: true
      });
      this.firstInstallmentAmountError = 'promise-to-pay.multi-ptp.first-installment-atLeastMinimum';
      return false;
    }
    get multiPTPRequest() {
      const installments = [{
        amount: +this.firstInstallmentAmountControl.value,
        date: this.datePipe.transform(this.firstInstallmentDate.value, ptpDateValueFormat),
        itemId: 1,
        paymentMethod: this.multiPTPFormControls.paymentMethod.value
      }];
      if (+this.secondInstallmentAmountControl.value > 0) {
        installments.push({
          amount: +this.secondInstallmentAmountControl.value,
          date: this.datePipe.transform(this.secondInstallmentDate.value, ptpDateValueFormat),
          itemId: 2,
          paymentMethod: this.multiPTPFormControls.paymentMethod.value
        });
      }
      return {
        installments
      };
    }
    ngOnInit() {
      this.firstInstallmentAmountControl.setValue(this.firstInstallmentAmountValue);
      this.setSecondInstallmentAmount();
    }
    ngOnChanges(changes) {
      this.setDayjsLocale(this.language);
      this.firstInstallmentDate.disable();
      this.secondInstallmentDate.disable();
      if (!changes.firstInstallmentEligibleDates?.firstChange) {
        if (this.firstInstallmentEligibleDates.length > 0) {
          this.firstInstallmentDate.enable();
          this.secondInstallmentDate.enable();
          this.firstInstallmentMinDate = new Date(this.firstInstallmentEligibleDates[this.firstInstallmentEligibleDates.length - 1]);
          this.firstInstallmentMaxDate = new Date(this.firstInstallmentEligibleDates[0]);
          this.updateSecondInstallmentDates(new Date(this.firstInstallmentEligibleDates[0]));
          this.firstInstallmentDate.setValue(dayjs(this.firstInstallmentEligibleDates[0]).locale(this.language).format(this.dateFormat));
          this.secondInstallmentDate.setValue(dayjs(this.secondInstallmentEligibleDates[0]).locale(this.language).format(this.dateFormat));
        }
      }
    }
    bindEligibleDates() {
      this.setEligibleDates.emit(this.multiPTPFormControls.paymentMethod.value);
      this.firstInstallmentDate.enable();
      this.secondInstallmentDate.enable();
    }
    handleSelectedDateChange(event) {
      this.firstInstallmentDate.setValue(dayjs(event).locale(this.language).format(this.dateFormat));
      this.secondInstallmentDate.setValue(this.secondInstallmentDate.value);
      this.updateSecondInstallmentDates(event);
    }
    setDayjsLocale(language) {
      if (language) {
        dayjs.locale(language);
      }
    }
    setSecondInstallmentAmount() {
      const value = round(this.pastDueBalance - +this.firstInstallmentAmountControl.value, 2);
      this.setSecondInstallmentFields(value);
    }
    setup() {
      if (this.firstInstallmentAmountControl.invalid || this.multiPTPForm.invalid || this.firstInstallmentDate.invalid || this.secondInstallmentDate.invalid) {
        this.firstInstallmentAmountControl.markAsTouched();
        this.firstInstallmentDate.markAsTouched();
        this.multiPTPFormControls.paymentMethod.markAsTouched();
        this.secondInstallmentDate.markAsTouched();
        return;
      }
      this.ptpFormDetails.emit(this.multiPTPRequest);
    }
    trackFormFieldEvent(name) {
      this.trackEvent.emit(`two installments - ${name}`);
    }
    updateSecondInstallmentDates(selectedDate) {
      const secondInstallmentsDates = [...this.secondInstallmentEligibleDates, ...this.firstInstallmentEligibleDates];
      const selectedDateIndex = secondInstallmentsDates.findIndex(date => dayjs(date).locale(this.language).isSame(dayjs(selectedDate)));
      this.secondInstallmentMinDate = new Date(secondInstallmentsDates[selectedDateIndex - 1]);
      this.secondInstallmentMaxDate = new Date(secondInstallmentsDates[0]);
    }
    patchGetHookContainer() {
      if (this.dpFirstContainer) {
        this.dpFirstContainer.getHookContainer = () => this.dpFirstContainer.field.formField.inputContainer;
      }
      if (this.dpSecondContainer) {
        this.dpSecondContainer.getHookContainer = () => this.dpSecondContainer.field.formField.inputContainer;
      }
    }
    setSecondInstallmentFields(value) {
      if (value > 0) {
        this.secondInstallmentAmountControl.setValue(value);
        this.secondInstallmentAmountControl.enable();
        this.secondInstallmentDate.setValidators(Validators.required);
      } else {
        this.secondInstallmentAmountControl.setValue(0);
        this.secondInstallmentAmountControl.disable();
        this.secondInstallmentDate.setValue('');
        this.secondInstallmentDate.disable();
        this.secondInstallmentDate.clearValidators();
      }
      this.secondInstallmentDate.updateValueAndValidity();
    }
    /** @nocollapse */
    static {
      this.ɵfac = function MultiPtpComponent_Factory(t) {
        return new (t || MultiPtpComponent)(i0.ɵɵdirectiveInject(i1$2.DatePipe), i0.ɵɵdirectiveInject(i2$1.UntypedFormBuilder));
      };
    }
    /** @nocollapse */
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: MultiPtpComponent,
        selectors: [["ss-multi-ptp"]],
        viewQuery: function MultiPtpComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c2, 5);
            i0.ɵɵviewQuery(_c3, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.dpFirstContainer = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.dpSecondContainer = _t.first);
          }
        },
        inputs: {
          firstEligibleDays: "firstEligibleDays",
          firstInstallmentEligibleDates: "firstInstallmentEligibleDates",
          language: "language",
          dateFormat: "dateFormat",
          pastDueBalance: "pastDueBalance",
          paymentOptions: "paymentOptions",
          ptpAnalyticsConfig: "ptpAnalyticsConfig",
          recommendedAmount: "recommendedAmount",
          secondInstallmentEligibleDates: "secondInstallmentEligibleDates"
        },
        outputs: {
          ptpFormDetails: "ptpFormDetails",
          setEligibleDates: "setEligibleDates",
          trackEvent: "trackEvent"
        },
        features: [i0.ɵɵNgOnChangesFeature],
        decls: 46,
        vars: 81,
        consts: [["dpFirstContainer", ""], ["dpSecondContainer", ""], [3, "ngSubmit", "formGroup"], ["translate", "promise-to-pay.multi-ptp.payment-method", 1, "text-title-5"], [1, "w-md-25", "mt-16", "mb-32"], ["translate", "promise-to-pay.setup-ptp.payment-method-label"], ["dsNativeControl", "", "formControlName", "paymentMethod", 3, "change", "focus"], [3, "value"], ["ssTrackError", "", 3, "error", "errorMessage"], [3, "hintMessage"], ["translate", "promise-to-pay.multi-ptp.first-installment", 1, "text-title-5"], [3, "change", "focus", "altText", "amountControl", "analyticsConfig", "autoFocus", "errorMessage", "hintMessage", "inputLabel", "language", "showAmountError", "wrapperClass"], ["translate", "promise-to-pay.multi-ptp.first-installment-date", 1, "text-title-5"], [3, "minDate", "maxDate", "language"], ["ds-datepicker-field", "", 1, "w-md-25", "mt-16", "mb-32", 3, "hideLabelVisually"], ["translate", "promise-to-pay.setup-ptp.date-hint"], ["dsInput", "", "dsDatepicker", "", "type", "date", 3, "selectedDateChange", "formControl", "format", "required", "readonly", "placeholder"], [1, "my-32"], ["translate", "promise-to-pay.multi-ptp.second-installment-amount", 1, "text-title-5"], [3, "focus", "altText", "amountControl", "analyticsConfig", "autoFocus", "inputLabel", "language", "readonly", "wrapperClass"], ["translate", "promise-to-pay.multi-ptp.second-installment-date", 1, "text-title-5"], ["dsInput", "", "dsDatepicker", "", "type", "date", 3, "formControl", "format", "required", "readonly", "placeholder"], [3, "translate"]],
        template: function MultiPtpComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "form", 2);
            i0.ɵɵlistener("ngSubmit", function MultiPtpComponent_Template_form_ngSubmit_0_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.setup());
            });
            i0.ɵɵelement(1, "div", 3);
            i0.ɵɵelementStart(2, "ds-form-field", 4)(3, "ds-input-label");
            i0.ɵɵelement(4, "span", 5);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(5, "select", 6);
            i0.ɵɵpipe(6, "translate");
            i0.ɵɵlistener("change", function MultiPtpComponent_Template_select_change_5_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.bindEligibleDates());
            })("focus", function MultiPtpComponent_Template_select_focus_5_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.trackFormFieldEvent("select payment method"));
            });
            i0.ɵɵrepeaterCreate(7, MultiPtpComponent_For_8_Template, 2, 2, "option", 7, i0.ɵɵrepeaterTrackByIdentity);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(9, MultiPtpComponent_Conditional_9_Template, 2, 4, "ds-error", 8);
            i0.ɵɵelement(10, "ds-hint", 9);
            i0.ɵɵpipe(11, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(12, "div", 10);
            i0.ɵɵelementStart(13, "ss-amount-field", 11);
            i0.ɵɵpipe(14, "translate");
            i0.ɵɵpipe(15, "currency");
            i0.ɵɵpipe(16, "translate");
            i0.ɵɵpipe(17, "translate");
            i0.ɵɵpipe(18, "translate");
            i0.ɵɵlistener("change", function MultiPtpComponent_Template_ss_amount_field_change_13_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.setSecondInstallmentAmount());
            })("focus", function MultiPtpComponent_Template_ss_amount_field_focus_13_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.trackFormFieldEvent("first installment amount"));
            });
            i0.ɵɵelementEnd();
            i0.ɵɵelement(19, "div", 12);
            i0.ɵɵelementStart(20, "ds-datepicker-container", 13, 0)(22, "ds-form-field", 14)(23, "ds-input-label");
            i0.ɵɵelement(24, "span", 15);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(25, "input", 16);
            i0.ɵɵlistener("selectedDateChange", function MultiPtpComponent_Template_input_selectedDateChange_25_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.handleSelectedDateChange($event));
            });
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(26, MultiPtpComponent_Conditional_26_Template, 2, 4, "ds-error", 8)(27, MultiPtpComponent_Conditional_27_Template, 2, 4, "ds-error", 8);
            i0.ɵɵelement(28, "ds-hint", 9);
            i0.ɵɵpipe(29, "translate");
            i0.ɵɵelementEnd()();
            i0.ɵɵelement(30, "hr", 17)(31, "div", 18);
            i0.ɵɵelementStart(32, "ss-amount-field", 19);
            i0.ɵɵpipe(33, "translate");
            i0.ɵɵpipe(34, "translate");
            i0.ɵɵlistener("focus", function MultiPtpComponent_Template_ss_amount_field_focus_32_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.trackFormFieldEvent("second installment amount"));
            });
            i0.ɵɵelementEnd();
            i0.ɵɵelement(35, "div", 20);
            i0.ɵɵelementStart(36, "ds-datepicker-container", 13, 1)(38, "ds-form-field", 14)(39, "ds-input-label");
            i0.ɵɵelement(40, "span", 15);
            i0.ɵɵelementEnd();
            i0.ɵɵelement(41, "input", 21);
            i0.ɵɵtemplate(42, MultiPtpComponent_Conditional_42_Template, 2, 4, "ds-error", 8)(43, MultiPtpComponent_Conditional_43_Template, 2, 4, "ds-error", 8);
            i0.ɵɵelement(44, "ds-hint", 9);
            i0.ɵɵpipe(45, "translate");
            i0.ɵɵelementEnd()()();
          }
          if (rf & 2) {
            i0.ɵɵproperty("formGroup", ctx.multiPTPForm);
            i0.ɵɵadvance(5);
            i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(6, 46, "promise-to-pay.multi-ptp.payment-method-alt"));
            i0.ɵɵadvance(2);
            i0.ɵɵrepeater(ctx.paymentOptions);
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(9, ctx.multiPTPFormControls.paymentMethod.touched && ctx.multiPTPFormControls.paymentMethod.invalid ? 9 : -1);
            i0.ɵɵadvance();
            i0.ɵɵproperty("hintMessage", i0.ɵɵpipeBind1(11, 48, "promise-to-pay.setup-ptp.payment-method-note"));
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("altText", i0.ɵɵpipeBind1(14, 50, "promise-to-pay.multi-ptp.first-installment-alt"))("amountControl", ctx.firstInstallmentAmountControl)("analyticsConfig", ctx.ptpAnalyticsConfig.paymentAmountFormError)("autoFocus", false)("errorMessage", i0.ɵɵpipeBind2(16, 58, ctx.firstInstallmentAmountError, i0.ɵɵpureFunction1(77, _c4, i0.ɵɵpipeBindV(15, 52, i0.ɵɵpureFunction2(74, _c0, ctx.recommendedAmount, ctx.language)))))("hintMessage", i0.ɵɵpipeBind1(17, 61, "promise-to-pay.multi-ptp.first-installment-note"))("inputLabel", i0.ɵɵpipeBind1(18, 63, "promise-to-pay.multi-ptp.first-installment-label"))("language", ctx.language)("showAmountError", ctx.showAmountError)("wrapperClass", "w-md-25 mb-32");
            i0.ɵɵadvance(7);
            i0.ɵɵproperty("minDate", ctx.firstInstallmentMinDate)("maxDate", ctx.firstInstallmentMaxDate)("language", ctx.language);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("hideLabelVisually", true);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("formControl", ctx.firstInstallmentDate)("format", ctx.dateFormat)("required", true)("readonly", true)("placeholder", ctx.dateFormat);
            i0.ɵɵadvance();
            i0.ɵɵconditional(26, ctx.firstInstallmentDate.touched && (ctx.firstInstallmentDate.errors == null ? null : ctx.firstInstallmentDate.errors.required) ? 26 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(27, ctx.firstInstallmentDate.touched && (ctx.firstInstallmentDate == null ? null : ctx.firstInstallmentDate.hasError("disabledDateSelected")) ? 27 : -1);
            i0.ɵɵadvance();
            i0.ɵɵproperty("hintMessage", i0.ɵɵpipeBind2(29, 65, "promise-to-pay.multi-ptp.first-installment-date-note", i0.ɵɵpureFunction1(79, _c5, ctx.firstEligibleDays - 1)));
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("altText", i0.ɵɵpipeBind1(33, 68, "promise-to-pay.multi-ptp.second-installment-amount-alt"))("amountControl", ctx.secondInstallmentAmountControl)("analyticsConfig", ctx.ptpAnalyticsConfig.paymentAmountFormError)("autoFocus", false)("inputLabel", i0.ɵɵpipeBind1(34, 70, "promise-to-pay.multi-ptp.second-installment-amount-label"))("language", ctx.language)("readonly", true)("wrapperClass", "w-md-25 mb-32");
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("minDate", ctx.secondInstallmentMinDate)("maxDate", ctx.secondInstallmentMaxDate)("language", ctx.language);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("hideLabelVisually", true);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("formControl", ctx.secondInstallmentDate)("format", ctx.dateFormat)("required", true)("readonly", true)("placeholder", ctx.dateFormat);
            i0.ɵɵadvance();
            i0.ɵɵconditional(42, ctx.secondInstallmentDate.touched && (ctx.secondInstallmentDate.errors == null ? null : ctx.secondInstallmentDate.errors.required) ? 42 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(43, ctx.secondInstallmentDate.touched && (ctx.secondInstallmentDate == null ? null : ctx.secondInstallmentDate.hasError("disabledDateSelected")) ? 43 : -1);
            i0.ɵɵadvance();
            i0.ɵɵproperty("hintMessage", i0.ɵɵpipeBind1(45, 72, "promise-to-pay.multi-ptp.second-installment-date-note"));
          }
        },
        dependencies: [i3.TranslateDirective, i4$2.AmountFieldComponent, i5$1.TrackErrorDirective, i6.FormFieldComponent, i6.InputFormDirective, i6.InputLabelComponent, i6.ErrorComponent, i6.HintComponent, i6.DatepickerFieldDirective, i6.DatepickerContainerComponent, i6.DatepickerDirective, i2$1.ɵNgNoValidate, i2$1.NgSelectOption, i2$1.ɵNgSelectMultipleOption, i2$1.DefaultValueAccessor, i2$1.SelectControlValueAccessor, i2$1.NgControlStatus, i2$1.NgControlStatusGroup, i2$1.RequiredValidator, i2$1.FormControlDirective, i2$1.FormGroupDirective, i2$1.FormControlName, i1$2.CurrencyPipe, i3.TranslatePipe],
        encapsulation: 2
      });
    }
  }
  return MultiPtpComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SinglePtpComponent = /*#__PURE__*/(() => {
  class SinglePtpComponent {
    constructor(datePipe, formBuilder) {
      this.datePipe = datePipe;
      this.formBuilder = formBuilder;
      // eslint-disable-next-line max-len
      this.ptpFormDetails = new EventEmitter();
      this.setEligibleDates = new EventEmitter();
      this.trackEvent = new EventEmitter();
      this.paymentDate = new FormControl('', [Validators.required]);
      this.singlePTPForm = this.formBuilder.group({
        paymentMethod: ['', Validators.required]
      });
    }
    get singlePTPFormControls() {
      return this.singlePTPForm.controls;
    }
    get singlePTPRequest() {
      return {
        installments: [{
          date: this.datePipe.transform(this.paymentDate.value, ptpDateValueFormat),
          amount: this.pastDueBalance,
          itemId: 1,
          paymentMethod: this.singlePTPFormControls.paymentMethod.value
        }]
      };
    }
    ngOnChanges(changes) {
      this.paymentDate.disable();
      this.setDayjsLocale(this.language);
      if (!changes.singlePTPEligibleDates?.firstChange) {
        if (this.singlePTPEligibleDates.length > 0) {
          this.paymentDate.enable();
          this.oneInstallmentMinDate = new Date(this.singlePTPEligibleDates[this.singlePTPEligibleDates.length - 1]);
          this.oneInstallmentMaxDate = new Date(this.singlePTPEligibleDates[0]);
          this.paymentDate.setValue(dayjs(this.singlePTPEligibleDates[0]).format(this.dateFormat));
        }
      }
    }
    ngAfterViewInit() {
      this.patchGetHookContainer();
    }
    bindEligibleDates() {
      this.setEligibleDates.emit(this.singlePTPFormControls.paymentMethod.value);
      this.paymentDate.enable();
    }
    handleSelectedDateChange(event) {
      this.paymentDate.setValue(dayjs(event).locale(this.language).format(this.dateFormat));
    }
    setDayjsLocale(language) {
      if (language) {
        dayjs.locale(language);
      }
    }
    setup() {
      if (this.singlePTPForm.invalid || this.paymentDate.invalid) {
        this.paymentDate.markAsTouched();
        this.singlePTPFormControls.paymentMethod.markAsTouched();
        return;
      }
      this.ptpFormDetails.emit(this.singlePTPRequest);
    }
    trackFormFieldEvent(name) {
      this.trackEvent.emit(`one installment - ${name}`);
    }
    patchGetHookContainer() {
      if (this.dpContainer) {
        this.dpContainer.getHookContainer = () => this.dpContainer.field.formField.inputContainer;
      }
    }
    /** @nocollapse */
    static {
      this.ɵfac = function SinglePtpComponent_Factory(t) {
        return new (t || SinglePtpComponent)(i0.ɵɵdirectiveInject(i1$2.DatePipe), i0.ɵɵdirectiveInject(i2$1.UntypedFormBuilder));
      };
    }
    /** @nocollapse */
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: SinglePtpComponent,
        selectors: [["ss-single-ptp"]],
        viewQuery: function SinglePtpComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c6, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.dpContainer = _t.first);
          }
        },
        inputs: {
          language: "language",
          dateFormat: "dateFormat",
          pastDueBalance: "pastDueBalance",
          paymentOptions: "paymentOptions",
          ptpAnalyticsConfig: "ptpAnalyticsConfig",
          singlePTPEligibleDates: "singlePTPEligibleDates"
        },
        outputs: {
          ptpFormDetails: "ptpFormDetails",
          setEligibleDates: "setEligibleDates",
          trackEvent: "trackEvent"
        },
        features: [i0.ɵɵNgOnChangesFeature],
        decls: 23,
        vars: 22,
        consts: [["dpContainer", ""], [3, "ngSubmit", "formGroup"], ["translate", "promise-to-pay.setup-ptp.payment-method-title", 1, "text-title-5"], [1, "w-md-25", "mt-16", "mb-32"], ["translate", "promise-to-pay.setup-ptp.payment-method-label"], ["dsNativeControl", "", "formControlName", "paymentMethod", 3, "change", "focus"], [3, "value"], ["ssTrackError", "", 3, "error", "errorMessage"], [3, "hintMessage"], ["translate", "promise-to-pay.setup-ptp.date-title", 1, "text-title-5"], [3, "minDate", "maxDate", "language"], ["ds-datepicker-field", "", 1, "w-md-25", "mt-16", "mb-32", 3, "hideLabelVisually"], ["translate", "promise-to-pay.setup-ptp.date-hint"], ["dsInput", "", "dsDatepicker", "", "type", "date", 3, "selectedDateChange", "formControl", "format", "required", "readonly", "placeholder"], [3, "translate"]],
        template: function SinglePtpComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "form", 1);
            i0.ɵɵlistener("ngSubmit", function SinglePtpComponent_Template_form_ngSubmit_0_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.setup());
            });
            i0.ɵɵelement(1, "div", 2);
            i0.ɵɵelementStart(2, "ds-form-field", 3)(3, "ds-input-label");
            i0.ɵɵelement(4, "span", 4);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(5, "select", 5);
            i0.ɵɵpipe(6, "translate");
            i0.ɵɵlistener("change", function SinglePtpComponent_Template_select_change_5_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.bindEligibleDates());
            })("focus", function SinglePtpComponent_Template_select_focus_5_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.trackFormFieldEvent("select payment method"));
            });
            i0.ɵɵrepeaterCreate(7, SinglePtpComponent_For_8_Template, 2, 2, "option", 6, i0.ɵɵrepeaterTrackByIdentity);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(9, SinglePtpComponent_Conditional_9_Template, 2, 4, "ds-error", 7);
            i0.ɵɵelement(10, "ds-hint", 8);
            i0.ɵɵpipe(11, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(12, "div", 9);
            i0.ɵɵelementStart(13, "ds-datepicker-container", 10, 0)(15, "ds-form-field", 11)(16, "ds-input-label");
            i0.ɵɵelement(17, "span", 12);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(18, "input", 13);
            i0.ɵɵlistener("selectedDateChange", function SinglePtpComponent_Template_input_selectedDateChange_18_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.handleSelectedDateChange($event));
            });
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(19, SinglePtpComponent_Conditional_19_Template, 2, 4, "ds-error", 7)(20, SinglePtpComponent_Conditional_20_Template, 2, 4, "ds-error", 7);
            i0.ɵɵelement(21, "ds-hint", 8);
            i0.ɵɵpipe(22, "translate");
            i0.ɵɵelementEnd()()();
          }
          if (rf & 2) {
            i0.ɵɵproperty("formGroup", ctx.singlePTPForm);
            i0.ɵɵadvance(5);
            i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(6, 16, "promise-to-pay.setup-ptp.payment-method-alt"));
            i0.ɵɵadvance(2);
            i0.ɵɵrepeater(ctx.paymentOptions);
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(9, ctx.singlePTPFormControls.paymentMethod.touched && ctx.singlePTPFormControls.paymentMethod.invalid ? 9 : -1);
            i0.ɵɵadvance();
            i0.ɵɵproperty("hintMessage", i0.ɵɵpipeBind1(11, 18, "promise-to-pay.setup-ptp.payment-method-note"));
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("minDate", ctx.oneInstallmentMinDate)("maxDate", ctx.oneInstallmentMaxDate)("language", ctx.language);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("hideLabelVisually", true);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("formControl", ctx.paymentDate)("format", ctx.dateFormat)("required", true)("readonly", true)("placeholder", ctx.dateFormat);
            i0.ɵɵadvance();
            i0.ɵɵconditional(19, ctx.paymentDate.touched && (ctx.paymentDate.errors == null ? null : ctx.paymentDate.errors.required) ? 19 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(20, ctx.paymentDate.touched && (ctx.paymentDate == null ? null : ctx.paymentDate.hasError("disabledDateSelected")) ? 20 : -1);
            i0.ɵɵadvance();
            i0.ɵɵproperty("hintMessage", i0.ɵɵpipeBind1(22, 20, "promise-to-pay.setup-ptp.date-note"));
          }
        },
        dependencies: [i3.TranslateDirective, i5$1.TrackErrorDirective, i6.FormFieldComponent, i6.InputFormDirective, i6.InputLabelComponent, i6.ErrorComponent, i6.HintComponent, i6.DatepickerFieldDirective, i6.DatepickerContainerComponent, i6.DatepickerDirective, i2$1.ɵNgNoValidate, i2$1.NgSelectOption, i2$1.ɵNgSelectMultipleOption, i2$1.DefaultValueAccessor, i2$1.SelectControlValueAccessor, i2$1.NgControlStatus, i2$1.NgControlStatusGroup, i2$1.RequiredValidator, i2$1.FormControlDirective, i2$1.FormGroupDirective, i2$1.FormControlName, i3.TranslatePipe],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return SinglePtpComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let PromiseToPayOptionsComponent = /*#__PURE__*/(() => {
  class PromiseToPayOptionsComponent {
    constructor(translateService) {
      this.translateService = translateService;
      this.selectedPTPOption = new EventEmitter();
      this.oneInstallmentClicked = false;
      this.twoInstallmentClicked = false;
      this.ptpOptions = [{
        caption: 'promise-to-pay.ptp-option.multi-alt',
        copy: 'promise-to-pay.ptp-option.multi',
        value: PtpOptions.Multi
      }, {
        caption: 'promise-to-pay.ptp-option.single-alt',
        copy: 'promise-to-pay.ptp-option.single',
        value: PtpOptions.Single
      }];
    }
    ngOnInit() {
      this.ptpOptionsControl = new UntypedFormControl(PtpOptions.Single, [Validators.required]);
      this.selectedPTP(this.ptpOptions[1].copy, this.ptpOptions[1].value);
    }
    selectedPTP(copy, value) {
      if (value === PtpOptions.Single && !this.oneInstallmentClicked) {
        this.oneInstallmentClicked = true;
      }
      if (value === PtpOptions.Multi && !this.twoInstallmentClicked) {
        this.twoInstallmentClicked = true;
      }
      this.selectedPTPOption.emit({
        name: this.translateService.instant(copy),
        option: value,
        oneInstallmentClicked: this.oneInstallmentClicked,
        twoInstallmentClicked: this.twoInstallmentClicked
      });
    }
    /** @nocollapse */
    static {
      this.ɵfac = function PromiseToPayOptionsComponent_Factory(t) {
        return new (t || PromiseToPayOptionsComponent)(i0.ɵɵdirectiveInject(i3.TranslateService));
      };
    }
    /** @nocollapse */
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: PromiseToPayOptionsComponent,
        selectors: [["ss-promise-to-pay-options"]],
        inputs: {
          ptpOption: "ptpOption"
        },
        outputs: {
          selectedPTPOption: "selectedPTPOption"
        },
        decls: 9,
        vars: 8,
        consts: [["translate", "promise-to-pay.select-ptp-option", 1, "text-title-4"], [3, "innerHTML"], [3, "ariaLabel", "formControl"], [1, "d-flex", "flex-wrap"], [1, "w-100", "w-md-auto", 3, "caption", "hasPadding", "ngClass", "value"], [1, "w-100", "w-md-auto", 3, "change", "caption", "hasPadding", "ngClass", "value"]],
        template: function PromiseToPayOptionsComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelement(0, "div", 0)(1, "div", 1);
            i0.ɵɵpipe(2, "translate");
            i0.ɵɵtemplate(3, PromiseToPayOptionsComponent_Conditional_3_Template, 2, 3, "div", 1);
            i0.ɵɵelementStart(4, "ds-radio-group", 2);
            i0.ɵɵpipe(5, "translate");
            i0.ɵɵelementStart(6, "div", 3);
            i0.ɵɵrepeaterCreate(7, PromiseToPayOptionsComponent_For_8_Template, 4, 11, "ds-selection", 4, i0.ɵɵrepeaterTrackByIdentity);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(2, 4, "promise-to-pay.select-ptp-option-body"), i0.ɵɵsanitizeHtml);
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(3, ctx.ptpOption === "single" ? 3 : -1);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ariaLabel", i0.ɵɵpipeBind1(5, 6, "promise-to-pay.select-ptp-option"))("formControl", ctx.ptpOptionsControl);
            i0.ɵɵadvance(3);
            i0.ɵɵrepeater(ctx.ptpOptions);
          }
        },
        dependencies: [i1$2.NgClass, i3.TranslateDirective, i6.RadioGroupComponent, i6.SelectionComponent, i2$1.NgControlStatus, i2$1.FormControlDirective, i3.TranslatePipe],
        encapsulation: 2
      });
    }
  }
  return PromiseToPayOptionsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let PromiseToPayFormsComponent = /*#__PURE__*/(() => {
  class PromiseToPayFormsComponent {
    constructor() {
      this.cancelPTP = new EventEmitter();
      this.selectedPTPOption = new EventEmitter();
      this.setupPTP = new EventEmitter();
      this.trackEvent = new EventEmitter();
      this.firstEligibleDays = MultiPtpEligibleDays.CREDIT_CARD_FIRST_INSTALLMENT;
      this.paymentOptions = [{
        copy: 'promise-to-pay.setup-ptp.payment-option-1',
        value: PtpPaymentMethods.CARD
      }, {
        copy: 'promise-to-pay.setup-ptp.payment-option-2',
        value: PtpPaymentMethods.BANK
      }];
    }
    get dateFormat() {
      return 'MM/DD/YYYY';
    }
    cancel() {
      this.cancelPTP.emit('overview');
    }
    selectedPTP(selectedPTP) {
      this.firstInstallmentEligibleDates = [];
      this.secondInstallmentEligibleDates = [];
      this.ptpOption = selectedPTP.option;
      this.selectedPTPOption.emit(selectedPTP);
    }
    setEligibleDates(paymentMethod) {
      if (!(this.currentDate instanceof Date && !isNaN(this.currentDate.getTime()))) {
        return;
      }
      const date = new Date(this.currentDate.toDateString());
      const days = this.getEligibleDays(paymentMethod);
      this.firstInstallmentEligibleDates = [];
      for (let i = 0; i <= days; i++) {
        this.firstInstallmentEligibleDates.push(date.toDateString());
        date.setDate(date.getDate() + 1);
      }
      this.firstInstallmentEligibleDates.reverse();
    }
    setMultiPTPEligibleDates(paymentMethod) {
      if (!(this.currentDate instanceof Date && !isNaN(this.currentDate.getTime()))) {
        return;
      }
      const date = new Date(this.currentDate.toDateString());
      this.firstEligibleDays = this.getFirstEligibleDays(paymentMethod);
      this.firstInstallmentEligibleDates = [];
      this.secondInstallmentEligibleDates = [];
      for (let i = 0; i < this.firstEligibleDays; i++) {
        this.firstInstallmentEligibleDates.push(date.toDateString());
        date.setDate(date.getDate() + 1);
      }
      this.firstInstallmentEligibleDates.reverse();
      const secondEligibleDays = this.getSecondEligibleDays(paymentMethod);
      for (let i = 0; i < secondEligibleDays; i++) {
        this.secondInstallmentEligibleDates.push(date.toDateString());
        date.setDate(date.getDate() + 1);
      }
      this.secondInstallmentEligibleDates.reverse();
    }
    setup($event) {
      this.setupPTP.emit($event);
    }
    submit() {
      this.ptpOption === PtpOptions.Single ? this.singlePtpComponent.setup() : this.multiPtpComponent.setup();
    }
    getEligibleDays(paymentMethod) {
      let eligibleDays = -1;
      if (paymentMethod === PtpPaymentMethods.CARD) {
        eligibleDays = PtpEligibleDays.CARD;
      } else {
        eligibleDays = PtpEligibleDays.BANK;
      }
      return eligibleDays;
    }
    getFirstEligibleDays(paymentMethod) {
      let eligibleDays = -1;
      if (paymentMethod === PtpPaymentMethods.CARD) {
        eligibleDays = MultiPtpEligibleDays.CREDIT_CARD_FIRST_INSTALLMENT;
      } else {
        eligibleDays = MultiPtpEligibleDays.BANK_FIRST_INSTALLMENT;
      }
      return eligibleDays;
    }
    getSecondEligibleDays(paymentMethod) {
      let eligibleDays = -1;
      if (paymentMethod === PtpPaymentMethods.CARD) {
        eligibleDays = MultiPtpEligibleDays.CREDIT_CARD_SECOND_INSTALLMENT;
      } else {
        eligibleDays = MultiPtpEligibleDays.BANK_SECOND_INSTALLMENT;
      }
      return eligibleDays;
    }
    /** @nocollapse */
    static {
      this.ɵfac = function PromiseToPayFormsComponent_Factory(t) {
        return new (t || PromiseToPayFormsComponent)();
      };
    }
    /** @nocollapse */
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: PromiseToPayFormsComponent,
        selectors: [["ss-promise-to-pay-forms"]],
        viewQuery: function PromiseToPayFormsComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(MultiPtpComponent, 5);
            i0.ɵɵviewQuery(SinglePtpComponent, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.multiPtpComponent = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.singlePtpComponent = _t.first);
          }
        },
        inputs: {
          currentDate: "currentDate",
          language: "language",
          pastDueBalance: "pastDueBalance",
          ptpAnalyticsConfig: "ptpAnalyticsConfig",
          recommendedAmount: "recommendedAmount"
        },
        outputs: {
          cancelPTP: "cancelPTP",
          selectedPTPOption: "selectedPTPOption",
          setupPTP: "setupPTP",
          trackEvent: "trackEvent"
        },
        decls: 13,
        vars: 15,
        consts: [[3, "selectedPTPOption", "ptpOption"], [1, "my-32"], [3, "firstInstallmentEligibleDates", "language", "dateFormat", "firstEligibleDays", "pastDueBalance", "paymentOptions", "ptpAnalyticsConfig", "recommendedAmount", "secondInstallmentEligibleDates"], [1, "d-block", "d-md-flex", "justify-content-end"], ["ds-button", "", "aria-describedby", "instructions", 1, "w-100", "w-md-auto", "mr-24", 3, "click"], ["ds-button", "", 1, "w-100", "w-md-auto", "mt-16", "mt-md-0", 3, "click", "variant"], [3, "ptpFormDetails", "setEligibleDates", "trackEvent", "firstInstallmentEligibleDates", "language", "dateFormat", "firstEligibleDays", "pastDueBalance", "paymentOptions", "ptpAnalyticsConfig", "recommendedAmount", "secondInstallmentEligibleDates"], [3, "ptpFormDetails", "setEligibleDates", "trackEvent", "language", "dateFormat", "pastDueBalance", "paymentOptions", "ptpAnalyticsConfig", "singlePTPEligibleDates"]],
        template: function PromiseToPayFormsComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "ss-promise-to-pay-options", 0);
            i0.ɵɵlistener("selectedPTPOption", function PromiseToPayFormsComponent_Template_ss_promise_to_pay_options_selectedPTPOption_0_listener($event) {
              return ctx.selectedPTP($event);
            });
            i0.ɵɵelementEnd();
            i0.ɵɵelement(1, "hr", 1);
            i0.ɵɵtemplate(2, PromiseToPayFormsComponent_Conditional_2_Template, 1, 9, "ss-multi-ptp", 2)(3, PromiseToPayFormsComponent_Conditional_3_Template, 1, 6);
            i0.ɵɵelementStart(4, "div", 3)(5, "button", 4);
            i0.ɵɵpipe(6, "translate");
            i0.ɵɵlistener("click", function PromiseToPayFormsComponent_Template_button_click_5_listener() {
              return ctx.submit();
            });
            i0.ɵɵtext(7);
            i0.ɵɵpipe(8, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(9, "button", 5);
            i0.ɵɵpipe(10, "translate");
            i0.ɵɵlistener("click", function PromiseToPayFormsComponent_Template_button_click_9_listener() {
              return ctx.cancel();
            });
            i0.ɵɵtext(11);
            i0.ɵɵpipe(12, "translate");
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵproperty("ptpOption", ctx.ptpOption);
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(2, ctx.ptpOption === "multi" ? 2 : 3);
            i0.ɵɵadvance(3);
            i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(6, 7, "promise-to-pay.continue"));
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(8, 9, "promise-to-pay.continue"), " ");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("variant", "secondary");
            i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(10, 11, "promise-to-pay.setup-ptp.cancel-btn-alt"));
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(12, 13, "promise-to-pay.setup-ptp.cancel-btn"), " ");
          }
        },
        dependencies: [i4.ButtonComponent, MultiPtpComponent, PromiseToPayOptionsComponent, SinglePtpComponent, i3.TranslatePipe],
        encapsulation: 2
      });
    }
  }
  return PromiseToPayFormsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let PromiseToPayMessageComponent = /*#__PURE__*/(() => {
  class PromiseToPayMessageComponent {
    /** @nocollapse */static {
      this.ɵfac = function PromiseToPayMessageComponent_Factory(t) {
        return new (t || PromiseToPayMessageComponent)();
      };
    }
    /** @nocollapse */
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: PromiseToPayMessageComponent,
        selectors: [["ss-promise-to-pay-message"]],
        inputs: {
          config: "config"
        },
        decls: 9,
        vars: 10,
        consts: [[1, "mt-24", 3, "showCloseButton", "variant"], [1, "d-flex", "flex-column", "flex-md-row"], [1, "flex-grow-1", "d-flex"], [1, "mr-8", 3, "caption", "color", "name"], [1, "text-body-lg", "text-bold", "mb-0", "mw-content", 3, "ngClass"], [1, "text-body", "mb-0", "mw-content", 3, "innerHTML"], [1, "d-flex", "flex-wrap", "flex-shrink-0", "align-self-md-start", "pl-16", "pl-md-0", "ml-16", "ml-md-0", "-mt-md-12"], ["ds-link", "", "target", "_blank", 3, "href"]],
        template: function PromiseToPayMessageComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "ds-alert", 0)(1, "div", 1)(2, "div", 2);
            i0.ɵɵelement(3, "ds-icon", 3);
            i0.ɵɵelementStart(4, "div");
            i0.ɵɵtemplate(5, PromiseToPayMessageComponent_Conditional_5_Template, 3, 6, "p", 4);
            i0.ɵɵelement(6, "p", 5);
            i0.ɵɵpipe(7, "translate");
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(8, PromiseToPayMessageComponent_Conditional_8_Template, 5, 7, "div", 6);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵproperty("showCloseButton", false)("variant", ctx.config == null ? null : ctx.config.alertVariant);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("caption", ctx.config == null ? null : ctx.config.iconCaption)("color", ctx.config == null ? null : ctx.config.alertVariant)("name", ctx.config == null ? null : ctx.config.alertIcon);
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(5, (ctx.config == null ? null : ctx.config.heading) ? 5 : -1);
            i0.ɵɵadvance();
            i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(7, 8, ctx.config == null ? null : ctx.config.body), i0.ɵɵsanitizeHtml);
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(8, !(ctx.config == null ? null : ctx.config.isSuccess) && !!(ctx.config == null ? null : ctx.config.alertLinkUrl) ? 8 : -1);
          }
        },
        dependencies: [i1$2.NgClass, i3$2.AlertComponent, i4$1.IconComponent, i5.LinkComponent, i3.TranslatePipe],
        encapsulation: 2
      });
    }
  }
  return PromiseToPayMessageComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let PromiseToPaySetupComponent = /*#__PURE__*/(() => {
  class PromiseToPaySetupComponent {
    constructor(config) {
      this.config = config;
      this.showPageTitle = true;
      this.isLoading = false;
      this.isOneInstallmentAlreadyClicked = false;
      this.isTwoInstallmentAlreadyClicked = false;
      this.ptpAnalyticsConfig = this.config.ptpAnalyticsConfig;
      this.addPromiseToPayAPIErrorHandler();
    }
    get notEligibleMessageConfig() {
      return this.config.notEligibleMessageConfig;
    }
    ngOnInit() {
      if (!this.isPtpDetailLoaded) {
        this.isLoading = true;
      }
    }
    ngOnChanges() {
      if (this.isPtpDetailLoaded) {
        this.isLoading = false;
        if (this.isPtpEligible) {
          this.trackSetupPTP();
        }
      }
    }
    navigateTo($event) {
      if ($event === 'payments/pay') {
        this.trackFormFieldAndButtonInteraction('make a payment here');
      }
      return this.config.navigateTo($event, this.confirmationConfig?.isSuccess ? {
        accountAlias: this.accountAlias,
        accountNumber: this.accountNumber,
        isPtpCreated: true
      } : null);
    }
    selectedPTPOption(selectedPTP) {
      this.ptpOption = selectedPTP.option;
      if (selectedPTP.oneInstallmentClicked && !this.isOneInstallmentAlreadyClicked) {
        this.trackFormFieldAndButtonInteraction(selectedPTP.name);
        this.isOneInstallmentAlreadyClicked = true;
      }
      if (selectedPTP.twoInstallmentClicked && !this.isTwoInstallmentAlreadyClicked) {
        this.trackFormFieldAndButtonInteraction(selectedPTP.name);
        this.isTwoInstallmentAlreadyClicked = true;
      }
    }
    reviewPTP(ptpRequest) {
      this.ptpStepper.next();
      this.editState = 'visible';
      this.ptpRequest = ptpRequest;
      this.ptpTableData = this.getPtpTableData(ptpRequest);
      this.config.trackEvent(this.ptpAnalyticsConfig.reviewPtp);
    }
    setupPTP() {
      this.isLoading = true;
      this.config.createPTP$(this.ptpRequest).pipe(tap(res => {
        this.isLoading = false;
        this.editState = res.config.isSuccess ? 'hidden' : 'visible';
        this.ptpTableData = this.getPtpTableData(this.ptpRequest);
        this.confirmationConfig = res.config;
        if (res.config.isSuccess) {
          this.trackSetupSuccess(this.ptpTableData);
        } else {
          this.trackError(res.error);
        }
        this.ptpStepper.next();
      }), take(1)).subscribe();
    }
    trackFormFieldAndButtonInteraction(currentFormFieldName) {
      if (currentFormFieldName === this.previousFormFieldName) {
        return;
      }
      const event = this.ptpAnalyticsConfig.formFieldAndButtonInteraction;
      event.additionalPayload.interaction.name = currentFormFieldName;
      this.previousFormFieldName = currentFormFieldName;
      this.config.trackEvent(event);
    }
    addPromiseToPayAPIErrorHandler() {
      if (!this.config.addPromiseToPayAPIErrorHandler) {
        return;
      }
      this.config.addPromiseToPayAPIErrorHandler([{
        useRegex: true,
        regex: new RegExp('/payments/promise-to-pay')
      }]);
    }
    getPtpTableData(ptpRequest) {
      const status = 'pending';
      const data = [{
        ...ptpRequest.installments[0],
        status
      }];
      if (this.ptpOption === PtpOptions.Single || ptpRequest.installments.length === 1) {
        return data;
      }
      data.push({
        ...ptpRequest.installments[1],
        status
      });
      return data;
    }
    trackError(error) {
      this.config.trackError({
        category: 'self serve',
        code: get(error.error?.status, 'code'),
        API: error.url?.replace(/customer\/accounts\/(.+)\/payments\/promise-to-pay/, 'customer/accounts/payments/promise-to-pay'),
        message: '',
        type: error.status === 401 || error.status === 422 ? 'user' : 'http',
        field: '',
        mappingKey: 'promiseToPayGeneralApiError'
      }, get(error.error?.status, 'codeName'));
    }
    trackSetupPTP() {
      const eventData = this.ptpAnalyticsConfig.setupPromiseToPay;
      eventData.additionalPayload.miscellaneous.name = this.isPtpNType ? 'N Type' : 'A Type';
      this.config.trackEvent(eventData);
    }
    trackSetupSuccess(ptpTableData) {
      const eventData = {
        ...this.ptpAnalyticsConfig.promiseToPaySetupSuccess
      };
      /* eslint-disable */
      eventData.additionalPayload.miscellaneous.name = ptpTableData.length > 1 ? `installment type: multiple, first payment date: ${ptpTableData[0].date}, first promised amount: ${ptpTableData[0].amount}, second payment date: ${ptpTableData[1].date}, second promised amount: ${ptpTableData[1].amount}` : `installment type: single, payment date: ${ptpTableData[0].date}, promised amount: ${ptpTableData[0].amount}`;
      eventData.additionalPayload.selfServe.paymentMethod = ptpTableData[0].paymentMethod;
      this.config.trackEvent(eventData);
    }
    /** @nocollapse */
    static {
      this.ɵfac = function PromiseToPaySetupComponent_Factory(t) {
        return new (t || PromiseToPaySetupComponent)(i0.ɵɵdirectiveInject(PromiseToPayConfigService));
      };
    }
    /** @nocollapse */
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: PromiseToPaySetupComponent,
        selectors: [["ss-promise-to-pay-setup"]],
        viewQuery: function PromiseToPaySetupComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c9, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.ptpStepper = _t.first);
          }
        },
        inputs: {
          accountAlias: "accountAlias",
          accountNumber: "accountNumber",
          currentDate: "currentDate",
          isPtpDetailLoaded: "isPtpDetailLoaded",
          isPtpEligible: "isPtpEligible",
          isPtpNType: "isPtpNType",
          language: "language",
          pastDueBalance: "pastDueBalance",
          recommendedAmount: "recommendedAmount",
          showPageTitle: "showPageTitle"
        },
        features: [i0.ɵɵNgOnChangesFeature],
        decls: 4,
        vars: 6,
        consts: [["ptpStepper", ""], [3, "ngClass"], [3, "a11yLoadingCopy", "a11yLoadedCopy", "isLoading"], [1, "text-body", 3, "innerHTML"], [1, "ds-borders", "ds-brcolor-misty"], [1, "text-body"], [3, "innerHTML"], ["ds-link", "", 3, "click"], [1, "m-24", "p-24", "ds-borders", "ds-brcolor-fog", "text-title-4"], [1, "d-block", 3, "price", "language"], [1, "m-24", 3, "ariaLabel"], [3, "buttonCopy", "buttonCaption", "completed", "editState", "required"], ["step-label", ""], ["step-label-completed", ""], [1, "text-title-4"], ["step-content", "", 1, "step-content"], [3, "cancelPTP", "selectedPTPOption", "setupPTP", "trackEvent", "currentDate", "language", "pastDueBalance", "ptpAnalyticsConfig", "recommendedAmount"], [3, "required", "completed", "editState"], [1, "d-block", "mt-16", 3, "language", "tableData", "showSetupDetailsText", "showPaymentStatus"], [1, "d-block", "d-md-flex", "justify-content-end"], ["ds-button", "", "aria-describedby", "instructions", 1, "w-100", "w-md-auto", "mr-24", 3, "click"], ["ds-button", "", 1, "w-100", "w-md-auto", "mt-16", "mt-md-0", 3, "click", "variant"], [3, "config"], ["ds-button", "", 1, "w-100", "w-md-auto", "mt-24", 3, "click"]],
        template: function PromiseToPaySetupComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 1);
            i0.ɵɵtemplate(1, PromiseToPaySetupComponent_Conditional_1_Template, 3, 3, "h1")(2, PromiseToPaySetupComponent_Conditional_2_Template, 4, 2)(3, PromiseToPaySetupComponent_Conditional_3_Template, 3, 7, "ds-progress-spinner", 2);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c10, ctx.showPageTitle));
            i0.ɵɵadvance();
            i0.ɵɵconditional(1, ctx.showPageTitle ? 1 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(2, ctx.isPtpDetailLoaded ? 2 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(3, ctx.isLoading ? 3 : -1);
          }
        },
        dependencies: [i1$2.NgClass, i4.ButtonComponent, i5.LinkComponent, i5$2.PriceComponent, i6$1.ProgressSpinnerComponent, i7.StepperComponent, i7.StepComponent, PromiseToPayFormsComponent, PromiseToPayMessageComponent, PtpInstallmentComponent, i3.TranslatePipe],
        encapsulation: 2
      });
    }
  }
  return PromiseToPaySetupComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let PromiseToPayEffects = /*#__PURE__*/(() => {
  class PromiseToPayEffects {
    constructor(actions$, config, httpClient) {
      this.actions$ = actions$;
      this.config = config;
      this.httpClient = httpClient;
      this.loadPromiseToPay$ = createEffect(() => this.actions$.pipe(ofType(loadPromiseToPay), mergeMap(({
        payload
      }) => {
        const {
          accountNumber,
          accountAlias
        } = payload;
        return this.getPromiseToPay$(accountNumber, accountAlias).pipe(map(promiseToPayDetails => loadPromiseToPaySuccess({
          payload: {
            ...promiseToPayDetails,
            accountNumber
          }
        })), catchError(error => of(loadPromiseToPayFail({
          payload: {
            accountNumber,
            accountAlias,
            error: this.config.getErrorTrackingObject(error)
          }
        }))));
      })));
    }
    getPromiseToPay$(accountNumber, accountAlias) {
      const url = `${this.config.baseApiUrl}${accountAlias}/payments/promise-to-pay`;
      return this.httpClient.get(url, {
        headers: this.config.getHeaders()
      }).pipe(map(response => {
        if (!response || !response.content) {
          return {
            accountNumber
          };
        }
        return {
          accountNumber,
          ...response.content
        };
      }));
    }
    /** @nocollapse */
    static {
      this.ɵfac = function PromiseToPayEffects_Factory(t) {
        return new (t || PromiseToPayEffects)(i0.ɵɵinject(i1$3.Actions), i0.ɵɵinject(PromiseToPayConfigService), i0.ɵɵinject(i3$3.HttpClient));
      };
    }
    /** @nocollapse */
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: PromiseToPayEffects,
        factory: PromiseToPayEffects.ɵfac
      });
    }
  }
  return PromiseToPayEffects;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let PromiseToPayStoreModule = /*#__PURE__*/(() => {
  class PromiseToPayStoreModule {
    /** @nocollapse */static {
      this.ɵfac = function PromiseToPayStoreModule_Factory(t) {
        return new (t || PromiseToPayStoreModule)();
      };
    }
    /** @nocollapse */
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: PromiseToPayStoreModule
      });
    }
    /** @nocollapse */
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [StoreModule.forFeature(promiseToPayStateName, promiseToPayReducer), EffectsModule.forFeature([PromiseToPayEffects])]
      });
    }
  }
  return PromiseToPayStoreModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let PromiseToPayModule = /*#__PURE__*/(() => {
  class PromiseToPayModule {
    /** @nocollapse */static {
      this.ɵfac = function PromiseToPayModule_Factory(t) {
        return new (t || PromiseToPayModule)();
      };
    }
    /** @nocollapse */
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: PromiseToPayModule
      });
    }
    /** @nocollapse */
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        providers: [CurrencyPipe, DatePipe],
        imports: [CommonModule, TranslateModule, AlertComponent, AmountFieldModule, AnalyticsModule, ButtonComponent, FormModule, FormsModule, IconComponent, LinkComponent, ModalModule, PriceComponent, ProgressSpinnerComponent, PromiseToPayStoreModule, ReactiveFormsModule, StepperModule, TableModule]
      });
    }
  }
  return PromiseToPayModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { MultiPtpEligibleDays, PromiseToPayAlertComponent, PromiseToPayConfigService, PromiseToPayFacadeService, PromiseToPayModule, PromiseToPaySetupComponent, PtpDetailsColumns, PtpEligibleDays, PtpInfoModalComponent, PtpInstallmentComponent, PtpInstallmentsStatus, PtpOptions, PtpPaymentMethods, VALIDATE_PAYMENT_AMOUNT, ptpDateValueFormat };
